module.exports = __webpack_public_path__ + "img/grow_bend.436264c6.png";